"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DropEvent = /** @class */ (function () {
    function DropEvent(event, data) {
        this.nativeEvent = event;
        this.dragData = data;
    }
    return DropEvent;
}());
exports.DropEvent = DropEvent;
//# sourceMappingURL=drop-event.model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-drag-drop/src/shared/drop-event.model.js
// module id = 350
// module chunks = 1